export const isBrowser = typeof window !== 'undefined' && !global.__NODE__;
export const isNodeTesting = Boolean(global.__NODE_TESTING__);
// eslint-disable-next-line no-restricted-globals
export const supportsBroadcastChannel = 'BroadcastChannel' in self;
